import { get } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { Icon, List, Message } from "semantic-ui-react"

const NotificationsList = ({ notifications }) =>
	notifications.length > 0 ? (
		<List animated divided relaxed>
			{notifications.map((notification, index) => (
				<List.Item key={index}>
					<List.Header>{get(notification, "status.description")}</List.Header>
					<List.Description>
						<div>
							<Icon name="phone" /> {get(notification, "phoneNo")}
						</div>
						<div>
							<Icon name="calendar check outline" /> {get(notification, "createDate")}
						</div>
					</List.Description>
				</List.Item>
			))}
		</List>
	) : (
		<Message
			icon="frown"
			content="Brak notyfikacji"
		/>
	)

NotificationsList.propTypes = {
	notifications: PropTypes.array
}

NotificationsList.defaultProps = {
	notifications: []
}

export default NotificationsList



// WEBPACK FOOTER //
// ./src/containers/case-status-history/components/NotificationsList.js